import hgpDialog from './main';

export default {
  install(Vue) {
    Vue.component(hgpDialog.name, hgpDialog);
  },
};

